import DocumentMeta from 'react-document-meta';
import React, {Component} from 'react';
import {renderRoutes} from 'react-router-config';

import Header from './components/Header';

export default class App extends Component {

  render() {
    const meta = {
      title: 'Welcome | PersonaGenerator',
      description: 'Kickstart your marketing or product development',
      canonical: 'http://personagenerator.com',
      meta: {
        property: {
          'og:image': 'http://personagenerator.com/shareable.png',
          'twitter:card': 'summary_large_image',
          'twitter:site': '@MobilityLabs',
          'twitter:title': 'Create free printable & Shareable User Personas',
          'twitter:description': 'Kickstart your marketing or product development',
          'twitter:image': 'http://personagenerator.com/shareable-twitter.png?0001',
        }
      },
      auto: {
        ograph: true
      }
    };
    return (
      <div>
        <DocumentMeta {...meta} />
        <Header />
        <div className="container-fluid">
          {renderRoutes(this.props.route.routes)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/App.jsx